import React from "react";

function About() {
  return (
    <section className="grid__padding">
      <h3>¿Qué es Delivree?</h3>
      <p>
        <em>Delivree</em> es una aplicación web que le permite a los, pequeños y
        medianos, negocios llevar a cabo sus actividades comerciales usando los
        canales digitales.
      </p>
    </section>
  );
}

export default About;
